import { Link } from "react-router-dom";

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}